import { render, staticRenderFns } from "./auditoria.vue?vue&type=template&id=2d5b5854&scoped=true&"
import script from "./auditoria.vue?vue&type=script&lang=js&"
export * from "./auditoria.vue?vue&type=script&lang=js&"
import style0 from "./auditoria.vue?vue&type=style&index=0&id=2d5b5854&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d5b5854",
  null
  
)

export default component.exports